import { css, CSSResult } from 'lit'
import { csFormControl } from 'elements/_shared/form.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'

export const cseSelect = {
  backgroundColor: css`var(--cse-select-background-color, ${csFormControl.backgroundColor})`,
  backgroundColorDisabled: css`var(--cse-select-background-color-disabled, ${csFormControl.backgroundColorDisabled})`,
  borderWidth: css`var(--cse-select-border-width, ${csFormControl.borderWidth})`,
  borderColor: css`var(--cse-select-border-color, ${csFormControl.borderColor})`,
  borderColorDisabled: css`var(--cse-select-border-color-disabled, ${csFormControl.borderColorDisabled})`,
  borderColorError: css`var(--cse-select-border-color-error, ${csFormControl.borderColorError})`,
  borderColorSuccess: css`var(--cse-select-border-color-success, ${csFormControl.borderColorSuccess})`,
  borderRadius: css`var(--cse-select-border-radius, ${csFormControl.borderRadius})`,
  color: css`var(--cse-select-color, ${csFormControl.color})`,
  colorDisabled: css`var(--cse-select-color-disabled, ${csFormControl.colorDisabled})`,
  fontFamily: css`var(--cse-select-font-family, ${csFormControl.fontFamily})`,
  fontSize: css`var(--cse-select-font-size, ${csFormControl.fontSize})`,
  gap: css`var(--cse-select-gap, ${csSpacing.spacing05})`,
  height: css`var(--cse-select-height, ${csFormControl.height})`,
  outlineFocus: css`var(--cse-select-outline-focus, ${csFormControl.outlineFocus})`,
  paddingInline: css`var(--cse-select-padding-x, ${csFormControl.paddingInline})`,
  paddingBlock: css`var(--cse-select-padding-y, ${csFormControl.paddingBlock})`,
  paddingBlockMulti:css`var(--cse-select-multi-padding-y, ${csSpacing.spacing03})`,

  placeholderColor: css`var(--cse-select-placeholder-color, ${csFormControl.color})`,
}

export const style: CSSResult = css`
  :host {
    position: relative;
  }

  .form-field {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-style: solid;
    width: 100%;

    background-color: ${cseSelect.backgroundColor};
    border-width: ${cseSelect.borderWidth};
    border-color: ${cseSelect.borderColor};
    border-radius: ${cseSelect.borderRadius};
    color: ${cseSelect.color};
    font-family: ${cseSelect.fontFamily};
    font-size: ${cseSelect.fontSize};
    height: ${cseSelect.height};
    padding-block: ${cseSelect.paddingBlock};
    padding-inline: ${cseSelect.paddingInline};
    gap: ${cseSelect.gap};

    transition-property: border-color, color;
    transition-duration: ${csTransition.duration};
    transition-timing-function: ${csTransition.timingFunction};
  }

  .form-field.multi {
    height: auto;
    padding-block: ${cseSelect.paddingBlockMulti};
  }

  .form-field:not(.disabed) {
    cursor: pointer;
  }

  .form-field.active {
    outline: ${cseSelect.outlineFocus};
  }

  .form-field.disabled {
    background-color: ${cseSelect.backgroundColorDisabled};
    border-color: ${cseSelect.borderColorDisabled};
    color: ${cseSelect.colorDisabled};
    pointer-events: none;
  }

  .form-field .placeholder {
    color: ${cseSelect.placeholderColor};
  }

  .form-field.disabled .placeholder {
    color: inherit;
  }

  .form-field.valid-error {
    border-color: ${cseSelect.borderColorError};
  }

  .form-field.valid-success {
    border-color: ${cseSelect.borderColorSuccess};
  }

  .form-field .actions {
    display: flex;
    align-items: center;
    gap: ${cseSelect.gap};
  }

  [icon-role="cse-select.arrow"] {
    transition-duration: ${csTransition.duration};
    transition-property: transform;
    transition-timing-function: ${csTransition.timingFunction};
  }

  .form-field.active [icon-role="cse-select.arrow"] {
    transform: rotate(180deg);
  }

  .selection-chips {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    gap: ${cseSelect.gap};
    align-items: baseline;
    flex-wrap: wrap;
  }

  .selection {
    border: none;
    padding: 0;
    background: none;
    width: 100%;
    text-overflow: ellipsis;
    font-family: inherit;
    font-size: inherit;
    color: inherit;
    cursor: pointer;
    pointer-events: none;
  }

  .selection:focus {
    outline: none;
  }
`
